module.exports = __webpack_public_path__ + "static/media/img_uniongroup_mobile.aa328336.png";